import { CampaignsApi } from '../clients';
import { mapProfessionalCampaign } from '../mappers';

// The documented response is { eligibilities: [...] }; the bare-array and
// { response } / { data } envelopes are accepted too because the gateway has
// historically varied per service. Order is preserved — the service already
// sorts by matched_at DESC, so there is no client-side sort.
export const getProfessionalCampaigns = async (professionalId) => {
  const data = await CampaignsApi.getProfessionalCampaigns(professionalId);
  const list = Array.isArray(data)
    ? data
    : data?.eligibilities ?? data?.response ?? data?.data ?? [];

  return list.map(mapProfessionalCampaign);
};
